import { useTheme } from '@mui/material'
import { useEffect, useState } from 'react'
import tableActionsBlockStyles from './tableActionBlockStyles'

export const useNewPagination = (
  store: any,
  totalSize: number,
  setRenderTable: any
) => {
  const { page, setPage, setSize, size, setScrollHeight } = store
  const [pageInputValue, setPageInputValue] = useState(page + 1)
  const maxPage = Math.ceil(totalSize / size)
  const theme = useTheme()

  useEffect(() => {
    const pageValue = page + 1
    if (pageValue !== pageInputValue) {
      setPageInputValue(pageValue)
    }
  }, [page])

  const classes = tableActionsBlockStyles(theme, {
    inputValue: pageInputValue,
    total: totalSize,
    pageSize: size,
  })

  const labelDisableRows = (props: any) => {
    const { from, to, count } = props

    return from + '-' + to + ' ' + 'из' + ' ' + count
  }

  const handleInputPageChange = (event: any) => {
    const newPage = event.target.value ? Number(event.target.value) - 1 : 0

    if (newPage >= 0 && newPage < maxPage) {
      setRenderTable && setRenderTable(false)
      setPageInputValue(event.target.value)
      setPage(newPage)
    } else {
      setPageInputValue(page + 1)
    }
  }

  const onRowsPerPageChange = (e: any) => {
    setRenderTable && setRenderTable(false)
    setRenderTable && setScrollHeight(window.scrollY)
    setSize(e?.target?.value)
  }

  const onPageChange = (_e: React.MouseEvent | null, page: number) => {
    setRenderTable && setRenderTable(false)
    setPage(page)
  }

  return {
    handleInputPageChange,
    labelDisableRows,
    onRowsPerPageChange,
    onPageChange,
    classes: classes as any,
    page,
    size,
    maxPage,
    pageInputValue,
  }
}
